<template>
  <v-container>
    <v-layout wrap>
      <v-row
        align="center"
        justify="center"
        no-gutters
        style="min-height: calc(100vh - 100px)"
      >
        <v-col cols="4">
          <v-card elevation="4" light tag="section">
            <v-card-title>
              <v-layout align-center justify-space-between>
                <h3 class="headline">ONEPLAN</h3>
              </v-layout>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-form>
                <v-text-field
                  outline
                  label="Email"
                  type="text"
                  v-model="username"
                ></v-text-field>
                <v-text-field
                  outline
                  hide-details
                  label="Пароль"
                  type="password"
                  v-model="password"
                ></v-text-field>
              </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="login" :disabled="logging">
                <v-icon left icon="$mdiLock"></v-icon>
                Войти
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-layout>
  </v-container>
</template>
<script>
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
const AccountRepository = RepositoryFactory.get("accountRepository");

export default {
  data() {
    return {
      username: null,
      password: null,
      logging: false,
    };
  },
  methods: {
    async login() {
      this.logging = true;
      await AccountRepository.login({
        username: this.username,
        password: this.password,
      });
      this.logging = false;
    },
  },
};
</script>
